import SaveIcon from '@mui/icons-material/Save';
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { ToolsPanelButton } from "../../../screens/positions-and-orders/controls";
import ReactEcharts from "echarts-for-react";

type SavePortfolioZoomButtonProps = {
    chartRef: React.MutableRefObject<ReactEcharts | null>
};

export function SavePortfolioZoomButton({
    chartRef,
}: SavePortfolioZoomButtonProps){
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();
    
    const handle = async (): Promise<void> => {
        const instance = chartRef.current?.getEchartsInstance();
        if (!instance) {
            return;
        }

        const option = instance.getOption();

        const startValueX = Array.isArray(option.dataZoom) ? option.dataZoom[0].startValue : null;
        const endValueX = Array.isArray(option.dataZoom) ? option.dataZoom[0].endValue : null;

        const startValueY = Array.isArray(option.dataZoom) ? option.dataZoom[1].startValue : null;
        const endValueY = Array.isArray(option.dataZoom) ? option.dataZoom[1].endValue : null;
        
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.balanceStartValueX = startValueX;
            selectedPortfolio.portfolioSettings.balanceEndValueX = endValueX;
            selectedPortfolio.portfolioSettings.balanceStartValueY = startValueY;
            selectedPortfolio.portfolioSettings.balanceEndValueY = endValueY;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    };
    
    return (
        <ToolsPanelButton
            tooltipText="Save current zoom"
            disabled={false}
            onChanged={handle}
        >
            <SaveIcon sx={{
                height: '18px',
                width: '18px',
            }} />
        </ToolsPanelButton>
    );
}